
import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-white to-figgy-50 px-4">
      <div className="text-center max-w-md">
        <div className="mb-6 flex justify-center">
          <div className="relative">
            <span className="text-8xl font-display font-bold bg-clip-text text-transparent bg-gradient-to-r from-figgy-400 to-figgy-600">
              404
            </span>
            <div className="absolute -top-6 -right-6 w-20 h-20 bg-figgy-100 rounded-full blur-xl opacity-70 -z-10"></div>
            <div className="absolute -bottom-6 -left-6 w-20 h-20 bg-figgy-100 rounded-full blur-xl opacity-70 -z-10"></div>
          </div>
        </div>
        <h1 className="text-2xl font-display font-bold mb-3">Page not found</h1>
        <p className="text-muted-foreground mb-8">
          We couldn't find the page you're looking for. It might have been moved or doesn't exist.
        </p>
        <Button asChild className="bg-figgy-500 hover:bg-figgy-600 text-white">
          <Link to="/">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Return to home
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
